// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2eo27","header":"MessagesList_header__2w0vL","chat":"MessagesList_chat__2XCZ5"};